import driverPickupStatistic from '@/api/report/driver-pickup-statistic'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
    ...baseState,
    dateRange: [moment().format('DD-MM-YYYY'), moment().format('DD-MM-YYYY')],
    driverIds: [],
    summary: { assigned_pickups: 0, picked_up: 0, packages_on_delivery: 0 }
}

export const mutations = {
    ...baseMutations,
    SET_DATE_RANGE(state, dateRange) { state.dateRange = dateRange },
    SET_DRIVER_IDS(state, driverIds) { state.driverIds = driverIds },
    SET_SUMMARY(state, summary = {}) {
        state.summary = Object.assign({
            assigned_pickups: 0,
            picked_up: 0,
            packages_on_delivery: 0
        }, summary || {})
    }
}

export const actions = {
    fetch(context, attributes = {}) {
        const params = Object.assign({
            page: context.state.pagination.currentPage,
            perPage: context.state.pagination.perPage,
            date_range: context.state.dateRange,
            driver_ids: context.state.driverIds
        }, attributes)

        return driverPickupStatistic.viewData({ params }).then(response => {
            context.commit('SET_SUMMARY', response.summary)
            context.commit('RECEIVE_RESOURCES', response)
            return Promise.resolve(response)
        })
    }
}
